<template>
    <div id="share">
        <!-- <headerBg :headerBg="headerBg" class="headerBg"></headerBg> -->
        <div class="shareBox" :style="shareBoxBg">
            <div class="steam" :style="bgSty">
                <img :src="shareLogo" alt="" />
                <span>{{ type }}</span>
            </div>
            <div class="title">
                <span>2024数据报告</span>
                <img class="logo" src="../../assets/image/steam/logo.png" alt="" />
            </div>
            <div class="box" :style="borderSty">
                <div class="header" :style="botBorderSty">
                    <div class="userImg" :style="rightBorderSty">
                        <img :src="data.portrait" alt="" />
                    </div>
                    <div class="userId">
                        <div class="id" v-if="$route.query.type == 'steam'">ID：{{ data.steamUserName }}</div>
                        <div class="id" v-if="$route.query.type == 'psn'">ID：{{ data.psnUserName }}</div>
                        <div class="id" v-if="$route.query.type == 'xbox'">ID：{{ data.xblUserName }}</div>
                        <div class="id" v-if="$route.query.type == 'epic'">ID：{{ data.epic }}</div>
                        <div class="key" :style="topBorderSty">
                            {{ data.yearkeyWord[0] }}
                        </div>
                    </div>
                </div>
                <div class="mid" :style="botBorderSty">
                    <div class="left" :style="rightBorderSty">
                        <div
                            :style="bgSty"
                            class="price"
                            v-if="$route.query.type == 'steam' || $route.query.type == 'psn'"
                        >
                            游戏价值：{{ data.yearPlayPrice }}元
                        </div>
                        <div
                            :style="bgSty"
                            class="time"
                            v-if="$route.query.type == 'steam' || $route.query.type == 'psn'"
                        >
                            游戏时长：{{ data.yearPlayTime }}时
                        </div>
                        <div :style="bgSty" class="time" v-if="$route.query.type == 'xbox'">
                            成就点数：{{ achievementPoints }}
                        </div>
                        <div
                            :style="bgSty"
                            class="num"
                            v-if="$route.query.type == 'steam' || $route.query.type == 'psn'"
                        >
                            游戏数量：{{ data.yearPlayCount | numberToCurrency(0) }}个
                        </div>
                        <div :style="bgSty" class="num" v-if="$route.query.type == 'xbox'">
                            游戏数量：{{
                                Number(data.yearPlayTime) | numberToCurrency(0)
                            }}个<!--yearPlayTime游戏苏联字段名取错，应为yearPlayCount-->
                        </div>
                    </div>
                    <div class="right">
                        <div v-if="data.yearkeyWord.length > 1">#{{ data.yearkeyWord[1] }}#</div>
                        <div v-if="data.yearkeyWord.length > 2">#{{ data.yearkeyWord[2] }}#</div>
                        <div v-if="data.yearkeyWord.length > 3">#{{ data.yearkeyWord[3] }}#</div>
                        <div v-if="data.yearkeyWord.length > 4">#{{ data.yearkeyWord[4] }}#</div>
                    </div>
                </div>
                <div class="footer">
                    <div class="gameImg" :style="botBorderSty">
                        <img :src="data.gameCover" alt="" />
                        <div class="gameName" :style="gameNameBg">{{ data.gameName }}</div>
                    </div>
                    <div class="gameTime">
                        <div class="left" :style="rightBorderSty">
                            <div class="leftImg">
                                <img src="../../assets/image/steam/left.png" />
                            </div>

                            <span :style="colorSty" v-if="$route.query.type != 'xbox'">年度游戏</span>
                            <span :style="colorSty" v-if="$route.query.type == 'xbox'">年度成就</span>

                            <div class="rightImg">
                                <img src="../../assets/image/steam/right.png" />
                            </div>
                        </div>
                        <div class="right" v-if="$route.query.type != 'xbox'">
                            <div class="time1" :style="botBorderSty">{{ data.gamePlayTime }}<span class="time1Dw">h</span></div>

                            <div class="time2">游玩时间</div>
                        </div>
                        <div class="right" v-if="$route.query.type == 'xbox'">
                            <div class="time1" :style="botBorderSty">
                                {{ data.achievementPoints | numberToCurrency(0) }}<span class="time1Dw">G</span>
                            </div>
                            <div class="time2">成就点数</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <transition name="fade"> -->
            <div class="erweima" :style="erweimaSty">
                <div class="erweima_box" :style="borderSty">
                    <div class="icon">
                        <img :src="erwicon" alt="" />
                    </div>
                    <div class="txt">
                        <div>
                            <div class="txt1">长按扫描二维码</div>
                            <div class="txt2">查看我的{{ $route.query.type.toUpperCase() }}年度报告</div>
                        </div>
                        <div class="ewmImg">
                            <img :src="erweima" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        <!-- </transition> -->
    </div>
</template>

<script>
import headerBg from "../../components/headerBg.vue";
import { numberToCurrency } from "../../assets/js/numberToCurrency";
export default {
    filters: {
        numberToCurrency
    },
    props: {
        data: {
            type: [Object]
        },
        achievementPoints: {
            type: [Number]
        }
    },
    data() {
        return {
            type: "",

            headerBg: {
                height: "12.45rem",
                background: "url(" + require("../../assets/image/steam/headerBg.png") + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "300%",
                backgroundPosition: "8% 15%"
                // backgroundAttachment: 'fixed',
            },
            shareLogo: require("../../assets/image/" +
                this.$route.query.type +
                "/" +
                this.$route.query.type +
                "_small.png"),
            shareBoxBg: {},
            borderSty: {},
            topBorderSty: {},
            rightBorderSty: {},
            leftBorderSty: {},
            botBorderSty: {},
            bgSty: {},
            colorSty: {},
            iconbgSty: {},
            erweimaSty: {},
            gameNameBg: {
                background:
                    "url(" +
                    require("../../assets/image/" + this.$route.query.type + "/gameNameBg.png") +
                    ") no-repeat",
                backgroundSize: "100%"
            },

           

            erwicon: "",
            erweima: ""
        };
    },

    mounted() {
       this.erwicon = "https://image.gamersky.com/webimg13/app0116/"+this.$route.query.type+"SharLogo.png";
        this.erweima = require("../../assets/image/" +
            this.$route.query.type +
            "/" +
            this.$route.query.type +
            "Erweima.png");

        if (this.$route.query.type == "steam") {
            this.type = "STEAM";
            this.shareBoxBg = {
                background: "url(" + require("../../assets/image/" + this.$route.query.type + "/shareBg.png") + ")",
                backgroundColor: "#0C272E",
                backgroundSize: "65%",
                backgroundRepeat: "no-repeat",
                // backgroundAttachment: 'fixed',
                backgroundPosition: "top left"
            };
            this.topBorderSty.borderTop = "0.05rem solid #3090A2";
            this.topBorderSty.color = "#5EE6FF";
            this.colorSty.color = "#5EE6FF";
            this.rightBorderSty.borderRight = "0.05rem solid #3090A2";
            this.botBorderSty.borderBottom = "0.05rem solid #3090A2";
            this.leftBorderSty = "0.05rem solid #3090A2";
            this.borderSty.border = "0.05rem solid rgba(48,144,162,0.4)";

            this.bgSty.background = "#1F5561";
            this.iconbgSty.background = "#1A515C";
            this.erweimaSty.background = "#0C272E";

            document.getElementById("share").style.background =
                "url(" + require("../../assets/image/steam/headerBg.png") + ") #0B1E23 8% 0%/300% no-repeat";
        } else if (this.$route.query.type == "psn") {
            this.type = "PSN";
            this.shareBoxBg = {
                background: "url(" + require("../../assets/image/" + this.$route.query.type + "/shareBg.png") + ")",
                backgroundColor: "#13203F",
                backgroundSize: "65%",
                backgroundRepeat: "no-repeat",
                // backgroundAttachment: 'fixed',
                backgroundPosition: "top left"
            };
            this.topBorderSty.borderTop = "0.05rem solid #5EA6FF";
            this.topBorderSty.color = "#5EA6FF";
            this.colorSty.color = "#5EA6FF";
            this.rightBorderSty.borderRight = "0.05rem solid #5EA6FF";
            this.botBorderSty.borderBottom = "0.05rem solid #5EA6FF";
            this.leftBorderSty = "0.05rem solid #5EA6FF";
            this.borderSty.border = "0.05rem solid #5EA6FF";

            this.bgSty.background = "#31568C";
            this.iconbgSty.background = "#4B8BDB";
            this.erweimaSty.background = "#13203F";
            document.getElementById("share").style.background =
                "url(" + require("../../assets/image/steam/headerBg.png") + ") #0E172C 8% 0%/300% no-repeat";
        } else if (this.$route.query.type == "xbox") {
            this.type = "XBOX";
            this.shareBoxBg = {
                background: "url(" + require("../../assets/image/" + this.$route.query.type + "/shareBg.png") + ")",
                backgroundColor: "#0C2B1E",
                backgroundSize: "65%",
                backgroundRepeat: "no-repeat",
                // backgroundAttachment: 'fixed',
                backgroundPosition: "top left"
            };
            this.topBorderSty.borderTop = "0.05rem solid #30A266";
            this.topBorderSty.color = "#5EFF97";
            this.colorSty.color = "#5EFF97";
            this.rightBorderSty.borderRight = "0.05rem solid #30A266";
            this.botBorderSty.borderBottom = "0.05rem solid #30A266";
            this.leftBorderSty = "0.05rem solid #30A266";
            this.borderSty.border = "0.05rem solid #30A266";

            this.bgSty.background = "#195229";
            this.iconbgSty.background = "#30A266";
            this.erweimaSty.background = "#0C2B1E";
            document.getElementById("share").style.background =
                "url(" + require("../../assets/image/steam/headerBg.png") + ") #081B0F 8% 0%/300% no-repeat";
        }

        let that = this;
       

        that.base64Url(that.data.gameCover, function(res) {
            that.data.gameCover = "data:image/jpeg;base64," + res.ImageInBase64;
        });
        that.base64Url(that.erwicon, function(res) {
            that.erwicon = "data:image/jpeg;base64," + res.ImageInBase64;
        });
        that.getImg();

      
        
    },

    methods: {
        getNumber(val) {
            if (val) {
                return val.toFixed(0);
            }
        },

      
        upload(
            sourceImageFile,
            sourceImageUrl,
            //
            didUploadFinished,
            didUploadProgressUpdateTo = null
        ) {
            let request = new XMLHttpRequest();
            {
                let weakThis = this;
                request.upload.onprogress = function(event) {
                    let uploadProgress = Math.round(event.loaded / event.total);
                    //
                    if (didUploadProgressUpdateTo != null) {
                        didUploadProgressUpdateTo(uploadProgress);
                    }
                    //
                };
                request.onload = function(event) {
                        didUploadFinished(event);
                };
                request.onerror = function(event) {
                    didUploadFinished(event);
                };
            }
            request.open("POST", "//instrument.gamersky.com/HTTPHelper/UploadImageWithImageURL", true);
            //
            let form = new FormData();
            {
                if (sourceImageFile != null) {
                    form.append("imageFile", sourceImageFile);
                } else if (sourceImageUrl != null && sourceImageUrl.length > 0) {
                    form.append("imageURL", sourceImageUrl);
                }
            }

            ////////////////////////////////////////////////
            ////////////////////////////////////////////////
            ////////////////////////////////////////////////
            // !!!
            request.send(form);
            // !!!
            ////////////////////////////////////////////////
            ////////////////////////////////////////////////
            ////////////////////////////////////////////////
        },

        getImg() {
            let that=this;
            that.data.portrait=that.data.portrait.replace('https','http')
            that.upload(null,that.data.portrait,function(res){
            
                let url=res.target.response
                url=JSON.parse(url)
                if(url.original){
                    that.base64Url(url.original, function(res) {
                        that.data.portrait = "data:image/jpeg;base64," + res.ImageInBase64;
                    });
                }

                
            })
        },

        // 线上链接转为base64
        base64Url(Url, callback) {
            $.ajax({
                type: "get",
                url: "https://instrument.gamersky.com/httphelper/getBase64OfImage",
                data: {
                    imageUrl: Url
                },
                dataType: "json",
                success: function(response) {
                    if (typeof callback === "function") {
                        callback(response);
                    }
                }
            });
        },
    },
    components: {
        headerBg
    }
};
</script>

<style>
#share {
    padding: 6rem 1.95rem 0;
    /* height: 844px; */
    box-sizing: border-box;
    position: relative;
}
#share .shareBox {
    margin: 0 auto 1.15rem;
    padding: 2rem 0.8rem 0.85rem;
    box-sizing: border-box;
}
.steam {
    width: 3.45rem;
    height: 1.05rem;
    padding: 0.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-bottom: 0.25rem;
}
.steam img {
    width: 0.55rem;
    height: 0.55rem;
    margin-right: 0.15rem;
}
.steam span {
    font-size: 0.7rem;
    font-family: AlibabaPuHuiTiMedium;
    color: #ffffff;
    margin-bottom: 0.1rem;
}
#share .title {
    font-size: 1.05rem;
    font-family: AlibabaPuHuiTiBold;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-bottom: 0.8rem;
}
#share .title .logo {
    width: 2.6rem;
    height: 0.65rem;
}
#share .box {
    box-sizing: border-box;
}
#share .box .header {
    display: flex;
}
#share .box .header .userImg {
    width: 4.15rem;
    height: 4.15rem;
    background: #fff;

    /* box-sizing: border-box; */
}
#share .box .header .userImg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

#share .box .header .userId {
    width: 70%;
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.8);
}
#share .box .header .userId .id {
    padding: 0.4rem 0.6rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
#share .box .header .userId .key {
    /* border-top: 0.05rem solid #3090A2; */
    font-size: 1.05rem;
    font-family: AlibabaPuHuiTiBold;
    color: #5ee6ff;
    padding: 0.4rem 0.6rem;
    display: flex;
    align-items: center;
}
#share .box .mid {
    display: flex;
    /* justify-content: center;
    align-items: center;
    flex-direction: column; */
}
#share .box .mid .left {
    padding: 0.45rem 0.35rem;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
#share .box .mid .left div {
    width: 5.95rem;
    padding: 0.3rem 0 0.3rem 0.4rem;
    font-size: 0.6rem;
    text-align: left;
    font-family: Source Han Sans CN;
    color: #ffffff;
    line-height: 0.6rem;
    box-sizing: border-box;
}
#share .box .mid .left div:nth-child(2) {
    margin: 0.4rem 0;
}
#share .box .mid .right {
    padding: 0.25rem 0.7rem;
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.4);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 6rem;
    margin: 0 auto;
}
#share .box .mid .right div {
    margin-bottom: 0.65rem;
    line-height: 0.6rem;
}
#share .box .mid .right div:last-child {
    margin-bottom: 0;
}

#share .footer .gameImg {
    width: 13.9rem;
    height: 7.45rem;
    background: #fff;
    position: relative;
    margin-top: 0.55rem;
}
#share .footer .gameImg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

#share .footer .gameImg .gameName {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 13.95rem;
    height: 1.25rem;
    line-height: 1.3rem;
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    padding-left: 0.45rem;
}
#share .footer .gameTime {
    display: flex;
    height: 4rem;
}
#share .footer .gameTime .left {
    font-size: 1.25rem;
    font-family: AlibabaPuHuiTiBold;
    color: #5ee6ff;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 0.5rem;
    box-sizing: border-box;
}
#share .footer .gameTime .left span {
    padding: 0 1.9rem;
    display: block;
}
#share .footer .gameTime .left > div {
    width: 100%;
    height: 0.9rem;
}
#share .footer .gameTime .left > div img {
    width: 1.1rem;
    height: 0.9rem;
}
#share .footer .gameTime .left .leftImg {
    margin-left: 0.6rem;
}
#share .footer .gameTime .left .rightImg {
    text-align: right;
    margin-right: 0.6rem;
}
#share .footer .gameTime .right {
    text-align: center;
    width: 36%;
}
#share .footer .gameTime .right .time1 {
    /* padding: 0 0.45rem ; */
    font-size: 1.2rem;
    font-family: D-DINExp;
    font-weight: bold;
    color: #ffffff;

    height: 2.65rem;
    line-height: 2.65rem;
}
#share .footer .gameTime .right .time1Dw{
    font-size: 0.8rem;
    font-family: D-DINExp;
    font-weight: bold;
    color: #ffffff;
    margin-left: 5px;
}

#share .footer .gameTime .right .time2 {
    /* padding: 0.35rem 0; */
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.25rem;
}

#share .btn {
    display: flex;
    justify-content: space-between;
    padding: 0 2.6rem;
}
#share .btn > div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
#share .btn .icon {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    margin-bottom: 0.65rem;
    padding: 0.15rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
#share .btn .icon img {
    width: 1.1rem;
    height: 1.1rem;
    display: block;
}
#share .btn .icon > div {
    width: 2.45rem;
    height: 2.45rem;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
#share .btn .btnTxt {
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.8);
}

#share .erweima {
    width: 15.6rem;
    height: 5.2rem;
    background: #0c272e;
    padding: 0.8rem 0.75rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    opacity: 0;
  
}
.erweima_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.45rem 0.45rem 0.45rem 0.65rem;
}
.erweima_box .icon {
    width: 2.2rem;
    height: 2.3rem;
}
.erweima_box .txt {
    display: flex;
    align-items: center;
}
.erweima_box .txt1 {
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    opacity: 0.8;
    text-align: right;
}
.erweima_box .txt2 {
    font-size: 0.45rem;
    font-family: Source Han Sans CN;
    color: #ffffff;
    opacity: 0.4;
    transform: scale(0.75);
    transform-origin: right;
}
.erweima_box .ewmImg {
    width: 2.75rem;
    height: 2.75rem;
    margin-left: 0.5rem;
}
</style>
